webpackJsonp([37329907133730],{

/***/ 1077:
/***/ (function(module, exports) {

	module.exports = {"description":"","displayName":"Footer","methods":[{"name":"renderSocials","docblock":null,"modifiers":[],"params":[],"returns":null},{"name":"renderSections","docblock":null,"modifiers":[],"params":[],"returns":null},{"name":"renderLinks","docblock":null,"modifiers":[],"params":[{"name":"links","type":null}],"returns":null}],"props":{"socialRounded":{"type":{"name":"bool"},"required":false,"description":"Define if socials buttons are rounded.","defaultValue":{"value":"true","computed":false}},"socialUrl":{"type":{"name":"string"},"required":false,"description":"Url to share in socials networks.","defaultValue":{"value":"''","computed":false}},"copyright":{"type":{"name":"string"},"required":false,"description":"Text of copyright.","defaultValue":{"value":"''","computed":false}},"socials":{"type":{"name":"arrayOf","value":{"name":"string"}},"required":false,"description":"Array of string with values of socials networks to display.","defaultValue":{"value":"[]","computed":false}},"sections":{"type":{"name":"arrayOf","value":{"name":"shape","value":{"name":{"name":"string","required":false},"sections":{"name":"arrayOf","value":{"name":"shape","value":{"name":{"name":"string","required":false},"url":{"name":"string","required":false}}},"required":false}}}},"required":false,"description":"Sections to show.","defaultValue":{"value":"[]","computed":false}},"className":{"type":{"name":"string"},"required":false,"description":"Class to apply to icon.","defaultValue":{"value":"''","computed":false}},"style":{"type":{"name":"objectOf","value":{"name":"any"}},"required":false,"description":"Css style applied to the component","defaultValue":{"value":"null","computed":false}},"padding":{"type":{"name":"string"},"required":false,"description":"Padding to apply to Footer.","defaultValue":{"value":"'5'","computed":false}},"headerTextColor":{"type":{"name":"string"},"required":false,"description":"Text color of headers.","defaultValue":{"value":"'light'","computed":false}},"linkTextColor":{"type":{"name":"string"},"required":false,"description":"Text color of links.","defaultValue":{"value":"'light'","computed":false}},"copyrightTextColor":{"type":{"name":"string"},"required":false,"description":"Text color of copy right.","defaultValue":{"value":"'light'","computed":false}},"bgColor":{"type":{"name":"string"},"required":false,"description":"Background color of the footer.","defaultValue":{"value":"'dark'","computed":false}},"children":{"type":{"name":"union","value":[{"name":"arrayOf","value":{"name":"node"}},{"name":"node"}]},"required":false,"description":"Elements to show inside of Footer.","defaultValue":{"value":"null","computed":false}}},"filename":"/components/Footer/Footer.jsx"}

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _main = __webpack_require__(5);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _DetailsComponent = __webpack_require__(6);
	
	var _DetailsComponent2 = _interopRequireDefault(_DetailsComponent);
	
	var _footer = __webpack_require__(507);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _map = __webpack_require__(1077);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ComponentView = function (_React$Component) {
	  _inherits(ComponentView, _React$Component);
	
	  function ComponentView() {
	    _classCallCheck(this, ComponentView);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ComponentView.prototype.render = function render() {
	    return _react2.default.createElement(
	      _main2.default,
	      { pagePushedFunction: this.handlepushedPageLayout },
	      _footer2.default && _react2.default.createElement(_DetailsComponent2.default, {
	        name: _footer2.default.name,
	        linkGithub: 'https://github.com/front10/landing-page-book/tree/master/src/components/Footer',
	        description: _footer2.default.summary,
	        stories: _footer2.default.stories,
	        importCode: _footer2.default.import,
	        withStyles: _footer2.default.withStyles,
	        extractProps: _footer2.default.extractProps,
	        propsDescription: _map2.default.props
	      })
	    );
	  };
	
	  return ComponentView;
	}(_react2.default.Component);
	
	exports.default = ComponentView;
	module.exports = exports['default'];

/***/ }),

/***/ 507:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	    name: 'Footer',
	    summary: 'A document footer is a small section at the bottom of each page within a document. It is often used to display company data or copyright information.',
	    import: '',
	    withStyles: true,
	    extractProps: ['social', 'header', 'link', 'copyright'],
	    stories: [{
	        name: 'Basic',
	        summary: '',
	        code: '<Footer \n    socialUrl="https://front10.com"\n    socialPadding="2"\n    copyright="Front10, LLC"\n    socials={[\'facebook\', \'linkedin\', \'google\', \'twitter\']}\n    sections={[\n    {\n        name: \'Features\',\n        sections: [\n            {name: \'Cool stuff\',url: \'https://front10.com\'},\n            {name: \'Random feature\',url: \'https://front10.com\'},\n            {name: \'Team feature\',url: \'https://front10.com\'},\n            {name: \'Stuff for developers\',url: \'https://front10.com\'},\n            {name: \'Another one\',url: \'https://front10.com\'},\n            {name: \'Last time\',url: \'https://front10.com\'}\n        ]\n    },\n    {\n        name: \'Resources\',\n        sections: [\n            {name: \'Resource\',url: \'https://front10.com\'},\n            {name: \'Resource name\',url: \'https://front10.com\'},\n            {name: \'Another resource\',url: \'https://front10.com\'},\n            {name: \'Final resource\',url: \'https://front10.com\'}\n        ]\n    },\n    {\n        name: \'About\',\n        sections: [\n            {name: \'Team\',url: \'https://front10.com\'},\n            {name: \'Locations\',url: \'https://front10.com\'},\n            {name: \'Privacy\',url: \'https://front10.com\'},\n            {name: \'Terms\',url: \'https://front10.com\'}\n        ]\n    }]}\n/>',
	        tabsActive: ['code']
	    }, {
	        name: 'With children',
	        summary: '',
	        code: '<Footer>\n    <Row>\n        <Column margin="2">\n            <Copyright textColor="light" text="Front10, LLC" showAllRightText={false} />\n        </Column>\n        <Column margin="2">\n            <Image src="https://front10.com/img/logos/logo-main.png" width={80} alt="Front 10 logo"/>\n        </Column>\n        <Column margin="2">\n            <Social margin="2" type="twitter" url="https://front10.com" cssFilter="grayscale(100%)" />\n            <Social margin="2" type="facebook" url="https://front10.com" cssFilter="grayscale(100%)" />\n            <Social margin="2" type="linkedin" url="https://front10.com" cssFilter="grayscale(100%)" />\n        </Column>\n    </Row>\n</Footer>',
	        tabsActive: []
	    }]
	};
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-components-footer-js-2b9eeaf6b685a2c9c31d.js